import { DataMap } from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';

import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import ConstructionEntryModal from 'views/Construction/ConstructionEntryModal';
import { ProcessLableComponent } from 'components/Input/ProcessLableComponent';
import { NyukinLabelComponent } from 'components/Input/NyukinLabelComponent';
import { format } from 'date-fns';
import { useMaster } from 'context/MasterContext';
import { Chip } from '@mui/material';

import NyukinCommentModal from 'views/Accounting/NyukinCommentModal';
import { ClientTypes, ProjectTypes, KoujiKbn1, KoujiKbn2, VisitReason } from 'constants/constants';

function ConstructionInfo(props) {
  const master = useMaster();

  const planerWithEmpty = [...master.planer, { id: 0, name: '' }];
  const planerMap = new DataMap(planerWithEmpty, 'id', 'name');
  var ProjectTypesMap = new DataMap(ProjectTypes, 'key', 'value');
  var clientTypeMap = new DataMap(ClientTypes, 'key', 'value');
  var koujiKbn1Map = new DataMap(KoujiKbn1, 'key', 'value');
  var koujiKbn2Map = new DataMap(KoujiKbn2, 'key', 'value');
  var ukeTypeMap = new DataMap(master.ukeType, 'id', 'name');
  var statusKbnMap = new DataMap(master.constructionStatus, 'id', 'name');
  var visitReasonMap = new DataMap(VisitReason, 'key', 'value');
  var robotTypesMap = new DataMap(
    [{ ROBOT_TYPE: 0, ROBOT_TYPE_NAME: '' }, ...master.robotTypes],
    'ROBOT_TYPE',
    'ROBOT_TYPE_NAME'
  );

  console.log(ClientTypes);

  // パラメタ
  const clientInfo = props.clientInfo; // 顧客情報
  const constructionList = props.constructionList; // 工事一覧
  const setConstructionList = props.setConstructionList; // 工事一覧
  const selectedSeikyuNo = props.selectedSeikyuNo; // 請求NO
  const setSelectedSeikyuNo = props.setSelectedSeikyuNo; // 請求NOの選択処理
  const search = props.search; // 検索処理
  const searchSeikyu = props.searchSeikyu; // 検索処理

  // グリッド
  const flexGrid = useRef();

  // 工事入力モーダルへのパラメタ
  const [constructionModalParam, setConstructionModalParam] = useState({});
  // 入金コメントモーダルのパラメタ
  const [nyukinCommentModalparam, setNyukinCommentModalparam] = useState({});

  // 工事ラジオの変更処理
  const handleOnClickContractRadio = (item) => (e) => {
    setSelectedSeikyuNo(item.SEIKYU_NO);
  };

  // 工事情報編集
  const handleOnClickEditConstruction = (mode, item) => () => {
    console.log(item);
    setConstructionModalParam({
      mode: mode,
      clientInfo: clientInfo,
      construction: {
        ...item,
        CLIENT_CD: clientInfo['CLIENT_CD'],
        SEIKYU_NO: item?.SEIKYU_NO,
        BIRTHDAY: clientInfo['BIRTHDAY'] ? format(clientInfo['BIRTHDAY'], 'yyyy/MM/dd') : '',
      },
    });
    // 一覧を再設定（なぜか選択色がクリアされてしまうので・・・）
    setConstructionList([...constructionList]);
  };

  // 工事入力画面からのコールバック処理
  const callbakConstructionModal = (seikyuNo) => {
    // 再読み込み
    search(clientInfo.CLIENT_CD, seikyuNo);
    searchSeikyu(clientInfo.CLIENT_CD, seikyuNo);
  };

  useEffect(() => {
    const index = constructionList.indexOf(
      constructionList.find((x) => x.SEIKYU_NO == selectedSeikyuNo)
    );
    for (var i = 0; i < flexGrid.current.control.rows.length; i++) {
      flexGrid.current.control.rows[i].cssClass = i == index ? 'wj-state-selected' : '';
    }
  }, [constructionList, selectedSeikyuNo]);

  return (
    <>
      <Row>
        <Col>
          <div className="list-label1">工事履歴</div>
        </Col>
        <Col style={{ textAlign: 'right' }}>
          <Button
            className="material-symbols-rounded cell-icon btn-fill"
            variant="primary"
            title="工事作成"
            onClick={handleOnClickEditConstruction('add', {})}
          >
            add
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            <FlexGrid
              ref={flexGrid}
              itemsSource={constructionList}
              selectionMode={'None'}
              headersVisibility={'Column'}
              isReadOnly={true}
              allowSorting={false}
              loadedRows={(grid) => {
                grid.rows.forEach((ele, i) => {
                  ele.height = 38;
                });
              }}
            >
              <FlexGridColumn header="選" isReadOnly={true} width={28}>
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <input
                      type="radio"
                      checked={cell.item.SEIKYU_NO == selectedSeikyuNo}
                      onClick={handleOnClickContractRadio(cell.item)}
                    ></input>
                  )}
                />
              </FlexGridColumn>
              <FlexGridColumn
                binding="CONSTRUCTION_STATUS"
                header="ステータス"
                width={80}
                allowResizing={false}
                dataMap={statusKbnMap}
              ></FlexGridColumn>
              <FlexGridColumn binding="UKE_DATE" header="見積依頼日" width={95}></FlexGridColumn>
              <FlexGridColumn
                binding="KOUJI_MEI"
                header="工事名"
                width="1*"
                allowResizing={false}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="CONTRACT_NUMBER"
                header="契約番号"
                width={95}
              ></FlexGridColumn>
              <FlexGridColumn binding="KEI_DATE" header="契約日" width={95}></FlexGridColumn>
              <FlexGridColumn binding="" header="工事場所" width="1*" allowResizing={false}>
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <>{`${cell.item.CITY} ${cell.item.TOWN} ${cell.item.ADDRESS}`}</>
                  )}
                />
              </FlexGridColumn>
              <FlexGridColumn
                binding="SALES_TAN_CD"
                header="営業"
                width={80}
                allowResizing={false}
                dataMap={planerMap}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="GENBA_TAN_CD"
                header="現場"
                width={80}
                allowResizing={false}
                dataMap={planerMap}
              ></FlexGridColumn>
              <FlexGridColumn binding="HIKI_DATE" header="引渡し日" width={95}></FlexGridColumn>
              <FlexGridColumn
                binding="FINAL_AMOUNT"
                header="最終金額(税抜)"
                width={105}
                align={'right'}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="KOUJI_KBN2"
                header="区分④"
                width={80}
                allowResizing={false}
                dataMap={koujiKbn2Map}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="ROBOT_TYPE"
                dataMap={robotTypesMap}
                header="ﾛﾎﾞｯﾄ工事種類"
              ></FlexGridColumn>
              <FlexGridColumn binding="ROBOT_MAKER" header="ﾛﾎﾞｯﾄ機種名"></FlexGridColumn>
              <FlexGridColumn
                binding="VISIT_REASON"
                header="来店きっかけ"
                width={120}
                allowResizing={false}
                dataMap={visitReasonMap}
              ></FlexGridColumn>
              <FlexGridCellTemplate
                cellType="Cell"
                template={(cell) => {
                  const reason = visitReasonMap.getDisplayValue(cell.item.VISIT_REASON) || '';
                  const biko = cell.item.VISIT_REASON_BIKO || '';
                  return <span>{biko ? `${reason}（${biko}）` : reason}</span>;
                }}
              />
              <FlexGridColumn header="" binding="" isReadOnly={true} width={78}>
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <span>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant="primary"
                        title="編集"
                        onClick={handleOnClickEditConstruction('upd', cell.item)}
                        disabled={cell.item.SEIKYU_NO != selectedSeikyuNo}
                      >
                        edit
                      </Button>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant="danger"
                        title="削除"
                        onClick={handleOnClickEditConstruction('del', cell.item)}
                        disabled={cell.item.SEIKYU_NO != selectedSeikyuNo}
                      >
                        delete
                      </Button>
                    </span>
                  )}
                />
              </FlexGridColumn>
            </FlexGrid>
          </div>
        </Col>
      </Row>
      {/* 工事情報モーダル */}
      <ConstructionEntryModal
        params={constructionModalParam}
        callbak={callbakConstructionModal}
      ></ConstructionEntryModal>
      {/** 入金コメントモーダル画面 */}
      <NyukinCommentModal params={nyukinCommentModalparam} />
    </>
  );
}

export default ConstructionInfo;
